<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Products Categories List</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" :items-per-page="2000">
            <!-- start of table -->
            <v-data-table :headers="headers" :items="categories" :search="search">
            
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>


    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    headers: [
      { text: "Category Name", value: "Name" },
      { text: "Action", value: "action" }
    ],
    categories: [],
    disableDialog: false,
    selectedCategory: null,
    disableLoading: false
  }),
  methods: {
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/products-categorization/list`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getCategories();
  },
};
</script>